import { render, staticRenderFns } from "./examHeader.vue?vue&type=template&id=24a1ff29&scoped=true"
import script from "./examHeader.vue?vue&type=script&lang=js"
export * from "./examHeader.vue?vue&type=script&lang=js"
import style0 from "./examHeader.vue?vue&type=style&index=0&id=24a1ff29&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a1ff29",
  null
  
)

export default component.exports